<div class="d-flex layout flex-column" [class.layout--no-scroll]="isChatRoute">
  @if (isLoggedIn && !hideLayout()) {
    <app-header></app-header>
  }
  <main
    class="workspace-view flex-grow-1"
    [class.p-2]="!hideLayout() && !isChatRoute"
    [class.min-h-0]="isChatRoute"
    [class.overflow-hidden]="isChatRoute"
    [class.workspace-view--flush]="hideLayout()"
    cdkScrollable
  >
    <router-outlet></router-outlet>
  </main>
  @if (isLoggedIn && !isWeb && !hideLayout()) {
    <app-sidebar
      [tabs]="tabs()"
      [activeTabId]="activeTabId()"
      (addTab)="addTab()"
      (switchTab)="switchTab($event)"
      (closeTab)="closeTab($event)"
    ></app-sidebar>
  }
</div>
